import React from 'react';
import PropTypes from 'prop-types';
import StylePropType from 'react-style-proptype';

var Card = function Card(_ref) {
  var children = _ref.children,
      header = _ref.header,
      isMinimal = _ref.isMinimal,
      className = _ref.className,
      style = _ref.style;
  return React.createElement("div", {
    className: "card ".concat(className).concat(isMinimal ? ' card-minimal' : ''),
    style: style
  }, header && React.createElement("div", {
    className: "card-header"
  }, header), React.createElement("div", {
    className: "card-block"
  }, children));
};

Card.propTypes = {
  children: PropTypes.node.isRequired,
  header: PropTypes.node,
  isMinimal: PropTypes.bool,
  className: PropTypes.string,
  style: StylePropType
};
Card.defaultProps = {
  header: undefined,
  isMinimal: false,
  className: '',
  style: {}
};
export default Card;